import React from 'react';
import { useTranslation } from 'react-i18next';
import './ReadOnlyBanner.css';

/* Bandeau « lecture seule », affiché EN HAUT d'un écran de saisie quand le rôle
   n'a pas le droit d'écrire sur ce périmètre.

   Pourquoi en amont plutôt qu'au refus : le serveur répond « Droit d'écriture
   insuffisant » APRÈS la tentative, en petit texte. L'utilisateur a déjà saisi,
   il ne sait pas si c'est une panne ou une règle, et il recommence. On annonce
   la règle avant le geste — même principe que le plan des ventes.

   `scope` sert à nommer le périmètre concerné dans le message. */
export default function ReadOnlyBanner({ scopeLabel }) {
  const { t } = useTranslation();
  return (
    <div className="ro-banner" role="status">
      <span className="ro-banner__tag">{t('common:readOnly.tag', 'Lecture seule')}</span>
      <span>
        {scopeLabel
          ? t('common:readOnly.textScope', { scope: scopeLabel })
          : t('common:readOnly.text')}
      </span>
    </div>
  );
}
